// extracted by mini-css-extract-plugin
export default {"summary":"FoodsSumm_summary__XQ9mO"};